export default __webpack_public_path__ + "static/media/speer_logo_header.fd6ca103.svg";